module.exports = __webpack_public_path__ + "static/3-5088ecd019645e412ae84f1d9473bbb1.jpg";